import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
   state: {
      status      : '',
      titleSection: '',
      token       : localStorage.getItem('token') || '',
      user        : null
   },
   mutations: {
      changePageTitle(state, title) {
         state.titleSection = title
      },
      setDataUser(state, user) {
         state.user = user
      }
   },
   actions: {
      title({commit}, title) {
         commit('changePageTitle', title)
      },
      userSystem({commit}, user) {
         commit('setDataUser', user)
      }
   },
   getters: {
      pageTitle: state => state.titleSection
   }
})
